import { Copy } from 'react-feather'
import styled from 'styled-components/macro'
import { gradientBorderSecondary } from 'theme/styles'
import { useAccount, useEnsName } from 'wagmi'

import { useDisconnect } from '../../connection/wallet-connect'
import { CircularCloseIcon } from '../../nft/components/icons'
import { shortenAddress } from '../../nft/utils/address'
import { CopyHelper, ThemedText } from '../../theme'
import { ButtonOutlined, ButtonPrimary } from '../Button'
import { UserIconLarge } from '../Icons/UserLarge'

const Wrapper = styled.div`
  backdrop-filter: blur(12px);
  margin-top: 8px;
  padding: 16px;
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  background-color: ${({ theme }) => theme.backgroundModule};
  box-shadow: ${({ theme }) => theme.deepShadow};
  border-radius: 8px;

  ${gradientBorderSecondary}
`

const CloseButton = styled(ButtonOutlined)`
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px;
  width: 40px;
  height: 40px;
  box-shadow: none !important;
  border: none;

  & > svg {
    color: ${({ theme }) => theme.textPrimary};
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

const Title = styled.p`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.01em;
  margin: 12px 0;
  text-align: center;
`

const CopyWrapper = styled(ThemedText.SubHeader)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 46px;
  background: ${({ theme }) => theme.background};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.borderPrimary};
`

const CopyText = styled(CopyHelper).attrs({
  InitialIcon: Copy,
  gap: 4,
  iconSize: 14,
  iconPosition: 'right',
})``

const DisconnectButton = styled(ButtonPrimary)`
  padding: 10px;
  font-size: 16px;
  line-height: normal;
`

type Props = {
  onClose: () => void
}

export const AccountPopoverDetails = ({ onClose }: Props) => {
  const { address } = useAccount()
  const { data: ENSName } = useEnsName()
  const { disconnectAsync } = useDisconnect()

  const disconnectWallet = async () => {
    await disconnectAsync?.()
    onClose()
  }

  if (!address) return null

  return (
    <Wrapper>
      <CloseButton onClick={onClose}>
        <CircularCloseIcon />
      </CloseButton>
      <UserIconLarge />
      <Title>Account</Title>
      <Content>
        <CopyWrapper color="textPrimary" fontWeight={500}>
          <CopyText fontSize={14} toCopy={ENSName ?? address}>
            {ENSName ?? shortenAddress(address, 8, 8)}
          </CopyText>
        </CopyWrapper>
        <DisconnectButton onClick={disconnectWallet}>Log out</DisconnectButton>
      </Content>
    </Wrapper>
  )
}
